'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _decisivIconixReact = require('decisiv-iconix-react');

var _decisivIconixReact2 = _interopRequireDefault(_decisivIconixReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Component: Button Icon Rectangle
 *
 * Produces a icon button tag styled to be rectangular.
 */
var modifierConfig = {
  hoverSuccess: function hoverSuccess(_ref) {
    var theme = _ref.theme;
    return '\n    &:hover {\n      border-color: ' + theme.colors.base.chrome200 + ';\n      span {\n        color: ' + theme.colors.status.success + ';\n      }\n    }\n  ';
  },

  hoverWarning: function hoverWarning(_ref2) {
    var theme = _ref2.theme;
    return '\n    &:hover {\n      border-color: ' + theme.colors.base.chrome200 + ';\n      span {\n        color: ' + theme.colors.status.warning + ';\n      }\n    }\n  ';
  },

  hoverDanger: function hoverDanger(_ref3) {
    var theme = _ref3.theme;
    return '\n    &:hover {\n      border-color: ' + theme.colors.base.chrome200 + ';\n      span {\n        color: ' + theme.colors.status.danger + ';\n      }\n    }\n  ';
  },

  active: function active(_ref4) {
    var theme = _ref4.theme;
    return '\n    border-color: ' + theme.colors.base.chrome200 + ';\n  ';
  },

  disabled: function disabled() {
    return '\n    opacity: 0.5;\n    pointer-events: none;\n  ';
  }
};

/* istanbul ignore next */
var styles = function styles(_ref5) {
  var theme = _ref5.theme;
  return '\n  background-color: ' + theme.colors.base.chrome000 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  border: 1px solid transparent;\n  cursor: pointer;\n  height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  line-height: normal;\n  outline: none;\n  transition: all 200ms ease;\n  width: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  &:hover {\n    border-color: ' + theme.colors.base.chrome200 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired,
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var ButtonIconRectangle = (0, _decisivUiUtils.buildStyledComponent)('ButtonIconRectangle', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

ButtonIconRectangle.Icon = _decisivIconixReact2.default;

exports.default = ButtonIconRectangle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ButtonIconRectangle/index.js
// module id = 1547
// module chunks = 2